<template>
	<div>
		<v-expansion-panel>
			<v-expansion-panel-content expand-icon="" class="panel-content">
				<template v-slot:header>
					<v-card-title>
						<h2 class="ml-1">Lista rankingowa</h2>
						<v-spacer/>
						<v-icon color="white">arrow_downward</v-icon>
					</v-card-title>
				</template>
				<v-card class="ranking-list">

					<v-card-text>
						<div class="ml-3 mt-3 mb-4">
							<strong>Opcje wyświetlania:</strong>
						</div>
						<v-radio-group v-model="filter" column>
							<v-radio :label="'Wszystkie oferty (liczba: ' + allCount + ')'" value="allOffers"/>
							<v-radio
								:label="'Oferty, które nie przeszły wstępnej weryfikacji (liczba: ' + rejectedCount + ')'"
								value="rejected"/>
							<!--(gdy którakolwiek z opinii formalnych jest na NIE; przeszły wstępną weryfikację, ale nie przeszły oceny formalnej)-->
							<v-radio
								:label="'Oferty, które nie przeszły opinii formalnej (liczba: ' + informalCount + ')'"
								value="informal"/>
							<div v-if="!ratingSettings.booleanEvaluation">
								<!--przeszły pozytywnie formalną, ale nie osiągnęły progu kwalifikacji-->
								<div style="display: flex">
									<v-radio
										:label="'Oferty, które nie osiągnęły progu kwalifikacji na posiedzenie komisji (liczba: ' +  belowQualificationThresholdCount + ')'"
										value="notQualified"/>
									<contest-ranking-list-view-tooltip text="Oferty, które przeszły wstępną weryfikację oraz opinię formalną, ale średnia
                    ocen przyznanych im przez opiniujących była zbyt niska, aby zakwalifikowały się na posiedzenie komisji.
                    Punktacja nie obejmuje ocen z tytułu dotychczasowej współpracy."/>
								</div>
								<div style="display: flex">
									<v-radio
										:label="'Oferty, które osiągnęły próg kwalifikacji na posiedzenie komisji (liczba: ' + overQualificationThresholdCount + ')'"
										value="qualified"/>
									<contest-ranking-list-view-tooltip text="Oferty, których średnia ocen przyznanych przez opiniujących była
                    wystarczająca, aby zakwalifikowały się na posiedzenie komisji. Punktacja nie obejmuje ocen z tytułu
                    dotychczasowej współpracy."/>
								</div>
								<!--osiągnęły próg kwalifikacji na posiedzeniu, ale nie osiągnęły progu rekomendacji do dofinansowania-->
								<div style="display: flex">
									<v-radio
										:label="'Oferty, które nie osiągnęły progu rekomendacji do dofinansowania (liczba: ' + belowRecommendationThresholdCount + ')'"
										value="notRecommended"/>
									<contest-ranking-list-view-tooltip text="Oferty, które były omawiane na posiedzeniu komisji i ich łączna ocena,
                    obejmująca średnią ocen przyznanych przez opiniujących, ocenę komisji oraz ocenę z tytułu dotychczasowej
                    współpracy jest niższa niż próg rekomendacji do dofinansowania."/>
								</div>
								<div style="display: flex">
									<v-radio style="margin-bottom: 8px"
										:label="'Oferty, które osiągnęły próg rekomendacji do dofinansowania (liczba: ' + overRecommendationThresholdCount + ')' "
										value="recommended"/>
									<contest-ranking-list-view-tooltip text="Oferty, które były omawiane na posiedzeniu komisji i ich łączna ocena,
                    obejmująca średnią ocen przyznanych przez opiniujących, ocenę komisji oraz ocenę z tytułu dotychczasowej
                    współpracy jest równa lub wyższa niż próg rekomendacji do dofinansowania."/>
								</div>
							</div>
							<div v-else>
								<!--gdy którakolwiek z opinii merytorycznych jest na NIE-->
								<v-radio
									:label="'Oferty, które otrzymały negatywną opinię merytoryczną (liczba: ' + negativeSubstantiveCount + ')'"
									value="negativeSubstantive"/>
								<!--wszystkie opinie merytoryczne na TAK-->
								<v-radio style="margin-bottom: 8px"
									:label="'Oferty, które otrzymały pozytywne opinie merytoryczne (liczba: ' + positiveSubstantiveCount + ')'"
									value="positiveSubstantive"/>
							</div>
							<v-radio
								:label="'Oferty rekomendowane przez komisję do dofinansowania (liczba: ' + isCommitteeRecommendedCount + ')'"
								value="committeeRecommended"/>
							<v-radio
								:label="'Oferty nierekomendowane przez komisję do dofinansowania (liczba: ' + isCommitteeNotRecommendedCount + ')'"
								value="committeeNotRecommended"/>
							<v-radio
								:label="'Oferty rezerwowe – rekomendacja komisji (liczba: ' + isCommitteeReservedCount + ')'"
								value="committeeReserved"/>
							<v-radio :label="'Oferty finansowane – decyzja ministra (liczba: ' + financedCount +')'"
								value="financed"/>
							<v-radio
								:label="'Oferty niefinansowane – decyzja ministra (liczba: ' + notFinancedCount + ')'"
								value="notFinanced"/>
							<v-radio
								:label="'Oferty rezerwowe – decyzja ministra (liczba: ' + pastRecommendationThresholdCount  + ')'"
								value="reserved"/>
							<v-radio :label="'Oferty realizowane (liczba: ' + approvedCount + ')'"
								value="approved"/>
						</v-radio-group>
					</v-card-text>
				</v-card>
			</v-expansion-panel-content>
		</v-expansion-panel>
		<handy-scroll class="handscrolls" ref="handscrolls">
			<ranking-list-table
				class="ranking-list-table"
				:table-name="viewTitle"
				:headers="evaluationsData.headers"
				:items="evaluationsData.items"
				:row-toolbar-actions-visible="false"
				:hide-pagination="true"
				:hideable-columns="true"
				:export-enabled="true"
				@item-updated="updateSummary"
				compact
			></ranking-list-table>
		</handy-scroll>
	</div>
</template>

<script>
	import {EvaluationSummary} from "@/api/generated/EvaluationSummary";
	import {PublicContest} from "@/api/generated/PublicContest";
	import {Numbers} from "@/utils/Numbers";
	import RankingListTable from "./RankingListTable";
	import HandyScroll, {EventBus} from "vue-handy-scroll";
  import ContestRankingListViewTooltip from "@/view/logged/contest/components/ContestRankingListViewTooltip";

	export default {
		name: "ContestRankingListView",

		components: {ContestRankingListViewTooltip, RankingListTable, HandyScroll},

		mixins: [Numbers],

		data() {
			return {

				filter: "allOffers",

				newItems: [],

				contestData: {
					id: this.$route.params.id,
					name: "",
					ratingSettings: {
						firstCommitteeCriteriaName: "Pierwsze kryterium",
						secondCommitteeCriteriaName: "Drugie kryterium",
					},
				},
				evaluationsData: {
					items: [],
					prefilteredItems: [],
					headers: [],
				},
				ratingSettings: {},
			};
		},

		watch: {
			evaluationsData () {
				EventBus.$emit("update");
			},
			filter: function () {
				this.refresh();
			},
		},

		computed: {

			viewTitle() {

				return "Lista rankingowa \"" + this.contestData.name + "\"";
			},

			requestedSum() {
				let sum = 0;
				this.evaluationsData.items.forEach(i => {
					sum += i.requestedDotations.reduce((prev, cur) => prev + cur);
				});
				return sum;
			},

			recommendedSum() {
				let sum = 0;
				this.evaluationsData.items.forEach(i => {
					sum += i.appliedDotations.reduce((prev, cur) => prev + cur);
				});
				return sum;
			},

			reductionSum() {
				return this.requestedSum - this.recommendedSum;
			},

			allCount() {
				return this.evaluationsData.prefilteredItems.length;
			},

			rejectedCount() {
				return this.evaluationsData.prefilteredItems.filter(
					x => x.isRejected,
				).length;
			},

			informalCount() {
				return this.evaluationsData.prefilteredItems.filter(
					x => !x.isRejected && x.isInformal,
				).length;
			},

      // oferty, mające inny status niż 'Odrzucona', nie mające negatywnej oceny formalnej oraz próg kwalifikacji na posiedzenie jest większy niż średnia dwóch najbardziej zbliżonych ocen merytorycznych
			belowQualificationThresholdCount() {
				return this.evaluationsData.prefilteredItems.filter(
					x => !x.isRejected && !x.isInformal &&
						this.ratingSettings.qualificationThreshold > parseFloat(x.averageSubstantiveEvaluationsPoints || 0),
				).length;
			},

      // oferty, mające inny status niż 'Odrzucona', nie mające negatywnej oceny formalnej oraz próg kwalifikacji jest mniejszy lub równy średniej dwóch najbardziej zbliżonych ocen merytorycznych
			overQualificationThresholdCount() {
				return this.evaluationsData.prefilteredItems.filter(
					x => !x.isRejected && !x.isInformal &&
						this.ratingSettings.qualificationThreshold <= parseFloat(x.averageSubstantiveEvaluationsPoints || 0),
				).length;
			},

      // oferty, mające inny status niż 'Odrzucona', nie mające negatywnej oceny formalnej, próg kwalifikacji jest mniejszy lub równy średniej dwóch najbardziej zbliżonych ocen merytorycznych oraz próg rekomendacji jest większy niż suma wszystkich punktów
      belowRecommendationThresholdCount() {
				return this.evaluationsData.prefilteredItems.filter(
					x => !x.isRejected && !x.isInformal &&
						this.ratingSettings.qualificationThreshold <= parseFloat(x.averageSubstantiveEvaluationsPoints || 0) &&
						this.ratingSettings.recommendationThreshold > this.totalScore(x),
				).length;
			},

      // oferty, mające inny status niż 'Odrzucona', nie mające negatywnej oceny formalnej, próg kwalifikacji jest mniejszy lub równy średniej dwóch najbardziej zbliżonych ocen merytorycznych oraz próg rekomendacji jest mniejszy lub równy sumie wszystkich punktów
			overRecommendationThresholdCount() {
				return this.evaluationsData.prefilteredItems.filter(
					x => !x.isRejected && !x.isInformal &&
              this.ratingSettings.qualificationThreshold <= parseFloat(x.averageSubstantiveEvaluationsPoints || 0) &&
              this.ratingSettings.recommendationThreshold <= this.totalScore(x),
				).length;
			},

			negativeSubstantiveCount() {
				return this.evaluationsData.prefilteredItems.filter(
					x => this.hasNegativeSubstantiveEvaluation(x),
				).length;
			},

			positiveSubstantiveCount() {
				return this.evaluationsData.prefilteredItems.filter(
					x => this.hasAllPositiveSubstantiveEvaluations(x),
				).length;
			},

			pastRecommendationThresholdCount() {
				return this.evaluationsData.prefilteredItems.filter(
					x => x.isReserved,
				).length;
			},

			isCommitteeReservedCount() {
				return this.evaluationsData.prefilteredItems.filter(
					x => this.isCommitteeReserved(x),
				).length;
			},

			isCommitteeRecommendedCount() {
				return this.evaluationsData.prefilteredItems.filter(
					x => this.isCommitteeRecommended(x),
				).length;
			},

			isCommitteeNotRecommendedCount() {
				return this.evaluationsData.prefilteredItems.filter(
					x => this.isCommitteeNotRecommended(x),
				).length;
			},

			financedCount() {
				return this.evaluationsData.prefilteredItems.filter(
					x => x.isFinanced,
				).length;
			},

			notFinancedCount() {
				return this.evaluationsData.prefilteredItems.filter(
					x => x.isNotFinanced,
				).length;
			},

			approvedCount() {
				return this.evaluationsData.prefilteredItems.filter(
					x => this.isApproved(x),
				).length;
			},
		},

		created() {
			loadContestData(this);
			this.reinitialize();
		},

		methods: {

			isBelowQualificationThreshold(o) {
				return !o.isRejected && !o.isInformal &&
					this.ratingSettings.qualificationThreshold > parseFloat(o.averageSubstantiveEvaluationsPoints || 0);
			},

			isOverQualificationThreshold(o) {
				return !o.isRejected && !o.isInformal &&
					this.ratingSettings.qualificationThreshold <= parseFloat(o.averageSubstantiveEvaluationsPoints || 0);
			},

			isBelowRecommendationThreshold(o) {
				return !o.isRejected && !o.isInformal &&
            this.ratingSettings.qualificationThreshold <= parseFloat(o.averageSubstantiveEvaluationsPoints || 0) &&
            this.ratingSettings.recommendationThreshold > this.totalScore(o);
			},

			isOverRecommendationThreshold(o) {
				return !o.isRejected && !o.isInformal &&
            this.ratingSettings.qualificationThreshold <= parseFloat(o.averageSubstantiveEvaluationsPoints || 0) &&
            this.ratingSettings.recommendationThreshold <= this.totalScore(o);
			},

			isCommitteeReserved(o) {
				return o.committeeDecision === "RESERVE";
			},

			isCommitteeRecommended(o) {
				return o.committeeDecision === "RECOMMENDED";
			},

			isCommitteeNotRecommended(o) {
				return o.committeeDecision === "NOT_RECOMMENDED";
			},

			hasAllPositiveSubstantiveEvaluations(x) {
				return !x.isRejected && !x.isInformal &&
					x.substantiveEvaluationDataList !== null &&
					x.substantiveEvaluationDataList.length >= 2 &&
					x.substantiveEvaluationDataList.map(item => item.substantiveEvaluationRecommending).every(y => y);
			},

			hasNegativeSubstantiveEvaluation(x) {
				return !x.isRejected && !x.isInformal &&
					x.substantiveEvaluationDataList !== null &&
					x.substantiveEvaluationDataList.length !== 0 &&
					x.substantiveEvaluationDataList.map(item => item.substantiveEvaluationRecommending).some(y => !y);
			},

			isApproved(x) {
				return x.isApproved;
			},

			totalScore(i) {
				return (parseFloat(i.relevancy) || 0) * this.contestData.ratingSettings.firstCommitteeCriteriaMultiplier
					+ (parseFloat(i.efficiency) || 0) * this.contestData.ratingSettings.secondCommitteeCriteriaMultiplier
					+ (parseFloat(i.averageSubstantiveEvaluationsPoints || 0))
					+ Math.round(parseFloat(i.collaborationEvaluation || 0) * 2);
			},

			refresh() {
				this.evaluationsData.items = [];
				if (this.filter === "allOffers") {
					this.evaluationsData.items = this.evaluationsData.prefilteredItems;
				} else if (this.filter === "rejected") {
					this.evaluationsData.items = this.evaluationsData.prefilteredItems.filter(
						x => x.isRejected,
					);
				} else if (this.filter === "informal") {
					this.evaluationsData.items = this.evaluationsData.prefilteredItems.filter(
						x => x.isInformal && !x.isRejected,
					);
				} else if (this.filter === "notQualified") {
					this.evaluationsData.items = this.evaluationsData.prefilteredItems.filter(
						x => this.isBelowQualificationThreshold(x),
					);
				} else if (this.filter === "qualified") {
					this.evaluationsData.items = this.evaluationsData.prefilteredItems.filter(
						x => this.isOverQualificationThreshold(x),
					);
				} else if (this.filter === "notRecommended") {
					this.evaluationsData.items = this.evaluationsData.prefilteredItems.filter(
						x => this.isBelowRecommendationThreshold(x),
					);
				} else if (this.filter === "recommended") {
					this.evaluationsData.items = this.evaluationsData.prefilteredItems.filter(
						x => this.isOverRecommendationThreshold(x),
					);
				} else if (this.filter === "negativeSubstantive") {
					this.evaluationsData.items = this.evaluationsData.prefilteredItems.filter(
						x => this.hasNegativeSubstantiveEvaluation(x),
					);
				} else if (this.filter === "positiveSubstantive") {
					this.evaluationsData.items = this.evaluationsData.prefilteredItems.filter(
						x => this.hasAllPositiveSubstantiveEvaluations(x),
					);
				} else if (this.filter === "committeeRecommended") {
					this.evaluationsData.items = this.evaluationsData.prefilteredItems.filter(
						x => this.isCommitteeRecommended(x),
					);
				} else if (this.filter === "committeeNotRecommended") {
					this.evaluationsData.items = this.evaluationsData.prefilteredItems.filter(
						x => this.isCommitteeNotRecommended(x),
					);
				} else if (this.filter === "committeeReserved") {
					this.evaluationsData.items = this.evaluationsData.prefilteredItems.filter(
						x => this.isCommitteeReserved(x),
					);
				} else if (this.filter === "financed") {
					this.evaluationsData.items = this.evaluationsData.prefilteredItems.filter(
						x => x.isFinanced,
					);
				} else if (this.filter === "notFinanced") {
					this.evaluationsData.items = this.evaluationsData.prefilteredItems.filter(
						x => x.isNotFinanced,
					);
				} else if (this.filter === "reserved") {
					this.evaluationsData.items = this.evaluationsData.prefilteredItems.filter(
						x => x.isReserved,
					);
				} else if (this.filter === "approved") {
					this.evaluationsData.items = this.evaluationsData.prefilteredItems.filter(
						x => x.isApproved,
					);
				}
			},

			reinitialize() {
				loadOffers(this);
			},

			updateSummary(summary) {
				processDynamicValues(summary, this.evaluationsData.headers);
				EvaluationSummary.put(this, summary,
					success => {
						this.$messagesBus.$emit("success", "Zapisano zmiany", success);
					},
					error => {
						this.$messagesBus.$emit("error", "Nie udało się wprowadzić zmian", error);
					});
			},
		},
	};

	function processDynamicValues(summary, headers) {
		const endsWithNumber = new RegExp("(.*)(\\d+)");
		headers.forEach(header => {
			if (header.editable && endsWithNumber.test(header.value)) {
				const result = endsWithNumber.exec(header.value);
				summary[result[1]][result[2] - 1] = summary[header.value];
			}
		});
	}

	function loadOffers(ctx) {
		let successHandler = (successResponse) => {
			successResponse = organizeIndexes(ctx, successResponse);
			ctx.evaluationsData.headers = processItemsAndBuildHeaders(ctx, successResponse);
			ctx.evaluationsData.items = successResponse;
			ctx.evaluationsData.prefilteredItems = successResponse;
			EventBus.$emit("update");
		};
		let errorHandler = (errorResponse) => {
			ctx.$messagesBus.$emit("error", "Nie udało się pobrać zbiorczej oceny", errorResponse);
		};

		EvaluationSummary.get(ctx, ctx.contestData.id, successHandler, errorHandler);
	}

	function loadContestData(ctx) {
		PublicContest.getRatingSettings(ctx, ctx.contestData.id, (response) => ctx.ratingSettings = response.ratingSettings);
		PublicContest.getEvaluationSummaryView(ctx, ctx.contestData.id,
			success => {
				ctx.contestData = success;
			}, error => {
				ctx.$messagesBus.$emit("error", "Nie udało się pobrać danych konkursu", error);
			});
	}

	function organizeIndexes(ctx, offers) {
		let index = 1;
		offers.forEach(offer => offer.index = index++);
		return offers;
	}

	function processItemsAndBuildHeaders(ctx, summaries) {
		let h = [];
		h.push(
			buildHeader("Lp.", "index", {s: false, f: false, t: "NUMBER", tooltip: "Liczba porządkowa"}),
			buildHeader("Nr oferty", "offerCode", {tooltip: "Numer oferty"}),
			buildHeader("Oferent", "mainBidderPolishName"),
			buildHeader("Tytuł oferty", "title"),
			buildHeader("Kraje", "accreditationCountryName"),
		);

    const formalEvaluationsColumnCount = Math.max(...summaries.map(offer => offer.formalEvaluations ? offer.formalEvaluations.length : 0));
    for (let i = 0; i < summaries.length; i++) {
			let s = summaries[i];
			// appendMultiHeader(ctx, h, s, "Wnioskowana kwota", "requestedDotations", {t: "CURRENCY", ic: " M", su: true}, requestedDotationsColumnCount);
			// appendMultiHeader(ctx, h, s, "Wkład własny", "ownContributions", {t: "CURRENCY", ic: " M"}, ownContributionsColumnCount);
			appendMultiHeader(ctx, h, s, "Opinia formalna", "formalEvaluations", {t: "BOOLEAN", ic: " "}, formalEvaluationsColumnCount);
			if (isSubstantiveEvaluationBinary(s)) {
				appendEvaluatorValueMultiHeader(ctx, h, s, true);
			} else {
				appendEvaluatorValueMultiHeader(ctx, h, s, false);
			}
		}

		if (!ctx.ratingSettings.booleanEvaluation) {
			h.push(
          buildHeader("Średnia zbliżonych ocen", "averageSubstantiveEvaluationsPoints", {t: "NUMBER"}),
          buildHeader("Ocena współpracy", "collaborationEvaluation", {t: "NUMBER"})
      );
		}

		h.push(
			buildHeader("Opinia placówki", "agencyEvaluation", {t: "BOOLEAN"})
		);

    const expertEvaluationsColumnCount = Math.max(...summaries.map(offer => offer.expertEvaluations ? offer.expertEvaluations.length : 0));
    for (let item of summaries) {
			appendMultiHeader(ctx, h, item, "Opinia eksperta", "expertEvaluations", {t: "BOOLEAN", ic: " "}, expertEvaluationsColumnCount);
		}

		if (!ctx.ratingSettings.booleanEvaluation) {
			h.push(
          buildHeader("KOMISJA " + ctx.contestData.ratingSettings.firstCommitteeCriteriaName, "relevancy", {t: "NUMBER", e: false}),
          buildHeader("KOMISJA " + ctx.contestData.ratingSettings.secondCommitteeCriteriaName, "efficiency", {t: "NUMBER", e: false}),
          buildHeader("KOMISJA łącznie", "committeePointsSum", {t: "NUMBER"}),
          buildHeader("Ocena łączna", "finalPointsSum",
              {
                t: "NUMBER",
                pp: (i) => (parseFloat(i.committeePointsSum || 0))
                    + (parseFloat(i.averageSubstantiveEvaluationsPoints || 0))
                    + (parseFloat(i.collaborationEvaluation || 0))
              },
          ));
		}

		h.push(buildHeader("Rekomendacja komisji", "committeeDecision", {t: "COMMITTEE_DECISION", e: false}));
		return h;
	}

	function appendEvaluatorValueMultiHeader(ctx, headers, item, booleanEvaluation) {
		const rootKey = booleanEvaluation ? "substantiveEvaluationsRecommendings" : "substantiveEvaluationsPointSums";

		for (let j = 0; j < item.substantiveEvaluationDataList.length; j++) {
			let key = rootKey + (j + 1);

			let substantiveEvaluationDataValue = booleanEvaluation
				? item.substantiveEvaluationDataList[j].substantiveEvaluationRecommending
				: item.substantiveEvaluationDataList[j].substantiveEvaluationValue;
			ctx.$set(item, key, substantiveEvaluationDataValue);

			if (!headers.some(h => h.value === key)) {
				let text = "Ocena" + (item.substantiveEvaluationDataList.length > 1 ? " O" + (j + 1) : "");

				if (booleanEvaluation) {
					headers.push(buildHeader(text, key, {t: "BOOLEAN"}));
				}
				else {
					headers.push(buildHeader(text, key, {t: "NUMBER"}));
				}
			}
		}
	}

	function appendMultiHeader(ctx, headers, item, rootText, rootKey, o = {}, columnCount) {
		const indexCaption = typeof o.ic === "undefined" ? "" : o.ic;

		for (let j = 0; j < item[rootKey].length; j++) {
			let key = rootKey + (j + 1);

			ctx.$set(item, key, item[rootKey][j]);

			if (!headers.some(h => h.value === key)) {
				let text = rootText + (columnCount > 1 ? indexCaption + (j + 1) : "");

				let singularOptions = Object.assign({}, o);
				singularOptions.pp = typeof o.pp === "function" ? o.pp(j + 1) : null;

				headers.push(buildHeader(text, key, singularOptions));
			}
		}
	}

	function buildHeader(text, value, o = {}) {
		return {
			text: text,
			value: value,
			type: o.t ? o.t : "TEXT",
			sortable: typeof o.s === "undefined" ? true : o.s,
			filterable: false,
			editable: typeof o.e === "undefined" ? false : o.e,
			summable: typeof o.su === "undefined" ? false : o.su,
			tooltip: typeof o.tooltip === "undefined" ? false : o.tooltip,
			postProcessor: o.pp,
			headerClass: "header-" + value,
			cellClass: "cell-" + value,
		};
	}

	function isSubstantiveEvaluationBinary(item) {
		return item.isBooleanSubstantiveEvaluation;
	}
</script>

<style scoped>
	.panel-content ::v-deep .v-expansion-panel__header {
		padding: 0 0 10px 0;
	}

	.panel-content ::v-deep .v-expansion-panel__header .v-expansion-panel__header__icon {
		display: none;
	}

	.ranking-list-table {
		display: inline-block;
	}

	.application.mediumFont h2 {
		font-size: 1.3em;
	}

	.application.largeFont h2 {
		font-size: 1.3em;
	}

	.application.mediumFont strong {
		font-size: 1.1em;
	}

	.application.largeFont strong {
		font-size: 1.1em;
	}

	strong {
		font-size: 16px;
	}

</style>
